import React, { useEffect } from "react";
import { _get } from "../Api";
import processData from "../components/InhouseReporting/DataProcessor";
import { DateRangePicker } from "react-date-range";
import { enGB } from "react-date-range/dist/locale";
import CircularProgress from "@material-ui/core/CircularProgress";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import ViewVats from "../components/ReportingViews/ViewVats";
import ViewTurnover from "../components/ReportingViews/ViewTurnover";
import ViewVoids from "../components/ReportingViews/ViewVoids";
import { Button, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import PdfGenerator from "../components/TablePdf/PdfGenerator";
import TextField from "@material-ui/core/TextField";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { Table as TablePDF } from "@david.kucsai/react-pdf-table/lib/Table";
import { format } from "date-fns";
import { toast, ToastContainer } from "react-toastify";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { useParams } from "react-router-dom";
import ViewSimpleReport from "../components/ReportingViews/ViewSimpleReport";
import ViewArticlesExtended from "../components/ReportingViews/ViewArticlesExtended";
import ViewMenusExtended from "../components/ReportingViews/ViewMenusExtended";
import ViewArticlegroupsExtended from "../components/ReportingViews/ViewArticlegroupsExtended";
import ViewPaymentMethodsInhouse from "../components/ReportingViews/ViewPaymentMethodsInhouse";

Date.formatted = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();

  return [this.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("-");
};

const fetchData = (spMerchantId, start, end) => {
  let url = "/nova/sp_merchant/" + spMerchantId + "/reporting/day";
  if (start && end) {
    url +=
      "?fromdate=" +
      start.getFullYear() +
      "-" +
      (start.getMonth() + 1) +
      "-" +
      start.getDate() +
      "&todate=" +
      end.getFullYear() +
      "-" +
      (end.getMonth() + 1) +
      "-" +
      end.getDate();
  } else if (start) {
    url += "?fromdate=" + start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate();
  } else if (end) {
    url += "?todate=" + end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate();
  }

  return _get(url)
    .then((res) => {
      if (!res.data) {
        return Promise.resolve(null);
      } else if (res.data.length === 0) {
        return Promise.resolve([]);
      } else {
        return Promise.resolve(res.data);
      }
    })
    .catch((e) => {
      return Promise.reject(null);
    });
};

export default function InHouseReporting(props) {
  const [range, setRange] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [data, setData] = React.useState(null);
  const articleLevelFromStorage = localStorage.getItem("articleLevelOption");
  const [articleLevel, setArticleLevel] = React.useState(
    articleLevelFromStorage != null ? articleLevelFromStorage : "articles"
  );
  let [fetching, setFetching] = React.useState(false);
  const [email, setEmail] = React.useState(
    localStorage.getItem("defaultEmailReporting") ? localStorage.getItem("defaultEmailReporting") : ""
  );
  const [spMerchant, setSpMerchant] = React.useState(null);
  const [spMerchantId] = React.useState(Number.parseInt(useParams().spMerchantId));

  useEffect(() => {
    function onChange() {
      setSpMerchant(cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId));
    }

    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }

    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChange);
  }, [spMerchantId]);

  if (!spMerchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const fetchWithDates = (start, end) => {
    setFetching(true);
    fetchData(spMerchantId, start, end)
      .then((data) => {
        window.reportingData = data;
        setData(processData(data));
        setFetching(false);
      })
      .catch((empty) => {
        setData(null);
      });
  };

  if (data === null && !fetching) {
    fetchWithDates(range.startDate, range.endDate);
  }

  let viewRangeInput = (
    <TablePDF data={[0]}>
      <TableHeaderPDF>
        <TableCellPDF weighting={0.3}>Reporting Inhouse</TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          From
        </TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          Until
        </TableCellPDF>
      </TableHeaderPDF>
      <TableBodyPDF>
        <TableCellPDF weighting={0.3}></TableCellPDF>
        <TableCellPDF weighting={0.3}>{format(range.startDate, "MMM d, yyyy")}</TableCellPDF>
        <TableCellPDF weighting={0.3} align={"right"}>
          {format(range.endDate, "MMM d, yyyy")}
        </TableCellPDF>
      </TableBodyPDF>
    </TablePDF>
  );
  let viewPaymentMethodsPdf = null;
  let viewTurnoverPdf = null;
  let viewVatsPdf = null;
  let viewVoidsPdf = null;
  let viewBillsPaidPdf = null;
  let viewArticleExtendedPdf = null;
  let viewMenuExtendedPdf = null;

  return (
    <div>
      <DateRangePicker
        locale={enGB}
        weekStartsOn={1}
        maxDate={new Date()}
        ranges={[range]}
        onChange={(newRange) => {
          if (newRange.selection.startDate !== range.startDate || newRange.selection.endDate !== range.endDate) {
            setRange({
              key: "selection",
              startDate: newRange.selection.startDate,
              endDate: newRange.selection.endDate,
            });

            fetchWithDates(newRange.selection.startDate, newRange.selection.endDate);
          }
        }}
      />
      {data === null || fetching ? (
        <div align="center">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <div>
          <Button
            variant={"outlined"}
            onClick={() => {
              PdfGenerator(
                [
                  viewRangeInput,
                  viewPaymentMethodsPdf,
                  viewTurnoverPdf,
                  viewVatsPdf,
                  viewVoidsPdf,
                  viewBillsPaidPdf,
                  viewMenuExtendedPdf,
                  viewArticleExtendedPdf,
                ],
                "",
                true
              );
            }}
          >
            Download PDF
          </Button>

          <TextField
            style={{ margin: "0 20px" }}
            label={"E-mail address"}
            variant={"outlined"}
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
          <Button
            variant={"outlined"}
            onClick={() => {
              localStorage.setItem("defaultEmailReporting", email);
              PdfGenerator(
                [
                  viewRangeInput,
                  viewPaymentMethodsPdf,
                  viewTurnoverPdf,
                  viewVatsPdf,
                  viewVoidsPdf,
                  viewBillsPaidPdf,
                  viewMenuExtendedPdf,
                  viewArticleExtendedPdf,
                ],
                email,
                false
              );
              toast.success("Verzonden!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }}
          >
            Send PDF
          </Button>

          <div id={"body-pdf"}>
            <div style={{ padding: "10px" }}>
              <ViewPaymentMethodsInhouse
                payments={data.payments}
                createPdf={(view) => {
                  viewPaymentMethodsPdf = view;
                }}
              />
            </div>

            {
              <div style={{ padding: "10px" }}>
                <ViewTurnover
                  totalTurnover={data.totalTurnover}
                  createPdf={(view) => {
                    viewTurnoverPdf = view;
                  }}
                />
              </div>
            }

            <AuthorizationWrapper
              permission={"vat"}
              child={
                <div style={{ padding: "10px" }}>
                  <ViewVats
                    vats={data.totalVats}
                    createPdf={(view) => {
                      viewVatsPdf = view;
                    }}
                  />
                </div>
              }
            />

            <div style={{ padding: "10px" }}>
              <ViewVoids
                voids={data.voids}
                createPdf={(view) => {
                  viewVoidsPdf = view;
                }}
              />
            </div>

            <div style={{ padding: "10px" }}>
              <ViewSimpleReport
                rows={[["Number of bills paid", data.numberOfPaidBills, ""]]}
                createPdf={(view) => {
                  viewBillsPaidPdf = view;
                }}
              />
            </div>

            <div style={{ padding: "10px" }}>
              <ViewMenusExtended
                menus={data.menus}
                createPdf={(view) => {
                  viewMenuExtendedPdf = view;
                }}
              />
            </div>

            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={articleLevel}
              onChange={(event) => {
                localStorage.setItem("articleLevelOption", event.target.value);
                setArticleLevel(event.target.value);
              }}
            >
              <FormControlLabel value="articles" control={<Radio />} label="Artikelen" />
              <FormControlLabel value="articlegroups" control={<Radio />} label="Artikelgroepen" />
            </RadioGroup>

            {articleLevel === "articles" ? (
              <div style={{ padding: "10px" }}>
                <ViewArticlesExtended
                  articles={data.articles}
                  createPdf={(view) => {
                    viewArticleExtendedPdf = view;
                  }}
                />
              </div>
            ) : (
              <div style={{ padding: "10px" }}>
                <ViewArticlegroupsExtended
                  articles={data.articles}
                  createPdf={(view) => {
                    viewArticleExtendedPdf = view;
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
